import { VueEditor } from "vue2-editor";
import { minimalToolBar } from '@/utils/constants';

export default {
    name: 'manage-facture-comment',
    components: {
        VueEditor
    },
    props: {
        proforma_id: Number,
        info_froforma: Object,
        fro_comment_toggler: Number
    },
    data() {
        return {
            customMinimalToolbar: minimalToolBar,
            commentaire: "",
            save_loading: false,
            error_message: ""
        }
    },

    watch: {
        fro_comment_toggler() {
            this.commentaire = this.info_froforma.fpro_commentaire
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        submit() {
            let data = {
                commentaire: this.commentaire,
                proforma_id: this.proforma_id
            }

            this.save_loading = true
            this.$store.dispatch('saveProformaCommentaire', data).then((response) => {
                if (response.success) {
                    this.$refs.close_fac_comment.click()
                    this.successToast("Commentaire ajouté avec succès")
                    this.$emit('emitFproforma')
                } else {
                    if (response.code == 403) {         // Permission denied
                        this.error_message = "Merci de reselectionner la facture proforma puis réessayer !"
                    } else if (response.code == 500) {
                        this.error_message = "Une erreur s'est produite !"
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.error_message = "Une erreur s'est produite !"
            })
        }
    }
}